export default {
  title: 'Os meus documentos',
  description: 'Os seus documentos empresariais enviados. Pode descarregá-los ou substituí-los a qualquer momento.',
  document_types: {
    owner_document: 'Documento de identidade do proprietário',
    business_document: 'Documento empresarial',
  },
  kinds: {
    vat_registration: 'Registo de IVA',
    trade_registration: 'Registo comercial',
    trade_license: 'Licença comercial',
    commercial_register_extract: 'Extrato do registo comercial',
    financial_statements: 'Demonstrações financeiras',
    other: 'Outro',
    passport: 'Passaporte',
    driver_license: 'Carta de condução',
    id_card: 'Cartão de identidade',
    residence_permit: 'Autorização de residência',
  },
  sides: {
    front: 'Frente',
    back: 'Verso',
  },
  fields: {
    document: 'Documento',
    kind: 'Tipo',
    side: 'Face',
    uploaded_at: 'Enviado',
    expires_at: 'Expira',
    retained_until: 'Retido até',
    deleted_at: 'Eliminado',
    storage_deleted_at: 'Eliminado definitivamente',
    actions: 'Ações',
  },
  values: {
    no_file_name: '—',
    version: 'v{{version}}',
  },
  filters: {
    type_placeholder: 'Filtrar por tipo de documento',
    kind_placeholder: 'Filtrar por tipo',
  },
  retention: {
    deletable: 'Eliminável',
    tooltip:
      'A lei alemã (GoBD / §147 AO) obriga-nos a conservar este documento até {{date}}. Só pode ser eliminado após essa data.',
    tooltip_no_date: 'Este documento está sujeito a um período de retenção legal e ainda não pode ser eliminado.',
  },
  buttons: {
    download: 'Transferir',
    download_front: 'Transferir frente',
    download_back: 'Transferir verso',
    reupload: 'Reenviar',
    delete: 'Eliminar',
  },
  empty: 'Ainda não carregou nenhum documento.',
  delete_modal: {
    title: 'Eliminar documento',
    description:
      'Escolha como eliminar este documento. «Eliminar» arquiva-o e oculta-o da sua lista. «Eliminar permanentemente» apaga os ficheiros definitivamente e só é possível após o término do período de retenção legal.',
    delete: 'Eliminar',
    permanently_delete: 'Eliminar permanentemente',
    cancel: 'Cancelar',
    retention_alert:
      'Estes documentos estão sujeitos a períodos de retenção legais ao abrigo da lei alemã (GoBD / §147 AO). Eliminar permanentemente um documento remove os seus ficheiros de forma irreversível.',
  },
  reupload_modal: {
    title: 'Reenviar documento',
    description: 'Carregue uma nova versão deste documento. A versão anterior será substituída.',
    type: {
      label: 'Tipo de documento',
      placeholder: 'Selecionar tipo de documento',
    },
    kind: {
      label: 'Categoria do documento',
      placeholder: 'Selecionar categoria do documento',
    },
    front: {
      label: 'Frente do documento',
    },
    back: {
      label: 'Verso do documento (opcional para alguns documentos)',
    },
    expires_at: {
      label: 'Data de validade do documento',
      placeholder: 'Selecionar data de validade',
    },
    buttons: {
      select_file: 'Selecionar ficheiro',
      submit: 'Carregar',
      cancel: 'Cancelar',
    },
  },
  toasts: {
    download_error: 'Falha ao transferir o documento.',
    delete_success: 'Documento eliminado com sucesso.',
    delete_error: 'Falha ao eliminar o documento.',
    reupload_success: 'Documento carregado com sucesso.',
    reupload_error: 'Falha ao carregar o documento.',
  },
};
